import React from 'react';

/**
 * Kinds of edits the agent-architect system agent can propose to the
 * AI Assistant editor. Each kind maps 1:1 to a backend tool (see
 * apps/crm-api/src/modules/ai-agents/ai-agents-tools/update-*.tool.ts)
 * and to a specific form field the editor will mutate when the user
 * clicks Accept.
 */
export type AgentProposalKind =
	| 'prompt'
	| 'firstMessage'
	| 'agentName'
	| 'agentDescription';

export type AgentProposalStatus = 'pending' | 'accepted' | 'rejected';

export interface AgentProposalContextValue {
	getStatus: (toolUsageId: number) => AgentProposalStatus;
	onAccept: (
		toolUsageId: number,
		kind: AgentProposalKind,
		newValue: string,
	) => void;
	onReject: (toolUsageId: number) => void;
}

/**
 * Context published by the AI Assistant editor so that the
 * AgentProposalRenderer (rendered inline as a tool widget inside the
 * architect chat) can read each proposal's current status and trigger
 * Accept/Reject. When the context is absent (e.g. the proposal tool
 * surfaces in some other chat surface), the renderer falls back to a
 * read-only display — no buttons.
 */
export const AgentProposalContext =
	React.createContext<AgentProposalContextValue | null>(null);
